/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types';

/** Common Components */
import Buttons from '../../../../components/ui/button/Buttons';
import FormCreator from '../../../../components/finalForms/FormCreator';

/** Common Services & Data Files */
import { AppIcons } from '../../../../data/appIcons';
import ToastService from '../../../../services/toastService/ToastService';

/** Configuration Files */
import projectStatusFormData from './config/ProjectStatus.Data';

/** RTK Query */
import {
  useAddProjectStatusMutation,
  useLazyGetProjectStatusByIDQuery,
  useUpdateProjectStatusByIDMutation
} from '../../../../app/services/projectStatusAPI';

const AddProjectStatus = (props) => {
  const ref = useRef();
  /* State*/
  const [formData, setFormData] = useState(projectStatusFormData);
  const ProjectId = props.projectId;
  // API'S Call
  const [addProjectStatus, {
    isSuccess: isProjectStatusAdded,
    isLoading: isProjectStatusAdding,
    data: addProjectStatusData
  },] = useAddProjectStatusMutation();

  const [updateProjectStatus, {
    isLoading: updateProjectStatusLoading,
    isSuccess: isSuccessUpdateProjectStatus,
    data: updateProjectStatusData
  }] = useUpdateProjectStatusByIDMutation();

  const [getProjectStatusById, {
    isFetching: isProjectStatusfetching,
    isSuccess: isProjectStatussuccess,
    data: ProjectStatusData
  },] = useLazyGetProjectStatusByIDQuery();

  //** useEffect's */
  useEffect(() => {
    formReset();
    if (props.selectedId) {
      getProjectStatusById(props.selectedId);
    }
  }, [props.selectedId, getProjectStatusById]);

  useEffect(() => {
    if (isProjectStatussuccess && !isProjectStatusfetching && ProjectStatusData) {
      if (ProjectStatusData) {
        let Data = { ...formData };
        const { statusName, isActive, isComplete, isBacklog, isDefault } = ProjectStatusData;
        Data.initialState = {
          statusName,
          isActive,
          isComplete,
          isBacklog,
          isDefault
        };
        setFormData(Data);
      }
    };
  }, [isProjectStatussuccess, isProjectStatusfetching, ProjectStatusData]);

  useEffect(() => {
    if (isSuccessUpdateProjectStatus && updateProjectStatusData) {
      if (updateProjectStatusData.errorMessage.includes("exists")) {
        ToastService.warning(updateProjectStatusData.errorMessage);
        return;
      } else {
        ToastService.success(updateProjectStatusData.errorMessage);
        backToList();
        const request = {
          pagination: {
            pageNumber: 1,
            pageSize: 40,
          },
          filters: { searchText: "" },
        };
        props.getProjectDataList(request);
      }
    }
  }, [isSuccessUpdateProjectStatus, updateProjectStatusData])

  useEffect(() => {
    if (isProjectStatusAdded && addProjectStatusData) {
      if (addProjectStatusData.errorMessage.includes("exists")) {
        ToastService.warning(addProjectStatusData.errorMessage);
        return;
      }
      else {
        ToastService.success(addProjectStatusData.errorMessage);
        backToList();
        const request = {
          pagination: {
            pageNumber: 1,
            pageSize: 40,
          },
          filters: { searchText: "" },
        };
        props.getProjectDataList(request);
      }
    }
  }, [isProjectStatusAdded, addProjectStatusData]);

  //** Funcation's */
  const handleSubmit = () => {
    const formData = ref.current.getFormData();
    if (formData) {
      if (!props.selectedId) {
        const requestData = {
          ...formData,
          statusName: formData.statusName,
          isActive: formData.isActive || true,
          isComplete: formData.isComplete || true,
          isBacklog: formData.isBacklog || false,
          isDefault: formData.isDefault || false,
          projectId: ProjectId
        }
        addProjectStatus(requestData);
      }
      else if (props.selectedId) {
        const DataUpdate = {
          ...formData,
          statusName: formData.statusName,
          isActive: formData.isActive,
          isComplete: formData.isComplete,
          isBacklog: formData.isBacklog,
          isDefault: formData.isDefault,
          projectStatusConfigurationId: props.selectedId,
          projectId: ProjectId
        }
        updateProjectStatus(DataUpdate)
      }
    }
  }

  const formReset = () => {
    const projectForm = { ...projectStatusFormData };
    projectForm.initialState = { ...projectStatusFormData.initialState };
    setFormData(projectForm);
  }

  const backToList = () => {
    props.onSidebarClose();
    formReset();
  };

  return (
    <div className="">
      <form>
        <div className="row">
          <FormCreator
            config={formData}
            ref={ref}
            {...formData} />
        </div>
      </form>
      <div className="row">
        <div className="col-12">
          <div className="form-btn d-flex justify-content-end">
            <Buttons
              buttonTypeClassName="dark-btn"
              onClick={backToList}
              buttonText="Cancel"
            />
            <Buttons
              buttonTypeClassName="theme-btn ml-4"
              onClick={handleSubmit}
              buttonText={props.selectedId ? "Update" : "Add"}
              isLoading={isProjectStatusAdding || updateProjectStatusLoading}
              imagePath={AppIcons.AddIcon}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
AddProjectStatus.propTypes = {
  selectedId: PropTypes.number,
  onSidebarClose: PropTypes.func.isRequired,
};
export default AddProjectStatus;